const state = {
  avatarUrl: null,
  trocarBeneficiario: false,
  titularIncapaz: false,
  dadosBeneficiario: {},
  familiaPessoa: [],
  isLoadingDadosPessoais: false
};

const getters = {
  getDadosBeneficiario: state => state.dadosBeneficiario,
  getFamiliaPessoa: state => state.familiaPessoa,
  getTitularIncapaz: state => state.titularIncapaz
};

const mutations = {
  clearAll(state) {
    state.avatarUrl = null;
    state.trocarBeneficiario = false;
    state.dadosBeneficiario = {};
    state.familiaPessoa = [];
    state.titularIncapaz = false;
    state.isLoadingDadosPessoais = false;
  },
  setAvatarUrl(state, value) {
    state.avatarUrl = value;
  },
  setTrocarBeneficiario(state, value) {
    state.trocarBeneficiario =
      value !== undefined ? value : !state.trocarBeneficiario;
  },
  setDadosBeneficiario(state, dadosBeneficiario) {
    state.dadosBeneficiario = dadosBeneficiario;
  },
  mergeDadosBeneficiarioPessoais(state, dadosPessoais) {
    state.dadosBeneficiario = {
      ...state.dadosBeneficiario,
      ...dadosPessoais
    };
  },
  setIsLoadingDadosPessoais(state, value) {
    state.isLoadingDadosPessoais = value;
  },
  setFamiliaPessoa(state, familiaPessoa) {
    state.familiaPessoa = familiaPessoa;
  },
  setTitularIncapaz(state, titularIncapaz) {
    state.titularIncapaz = titularIncapaz;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
